// @ts-nocheck

import {
	loadLivePersonAssets,
} from "../../utils/asset-loader-utils";

import { LiveChatError } from "../../utils/common-utils";

(function () {
	const bucketPath = '/livechat';
	let removeOutsideClickListener = null;
	const otherSelectors = {
		oneTrustPopUp: '#onetrust-consent-sdk',
	};

	const uiSelectors = {
		floatingButton: '.js-live-chat-button',
		floatingButtonIcon: '.live-chat-button__icon',
		floatingButtonLoading: '.js-live-chat-button-loading',
		chatDrawer: '.js-live-chat-drawer',
		closeButton: '.js-live-chat-drawer-close',
		serviceButtons: {
			artistButton: '.js-live-chat-drawer-artist-button',
			supportButton: '.js-live-chat-drawer-support-button'
		},
		warnings: {
			chatDrawerCookieWarning: '.js-live-chat-drawer-cookie-warning',
			chatDrawerWarning: '.js-live-chat-drawer-warning'
		},
		chatDrawerSuccess: '.js-live-chat-drawer-success',
		headerIcon: '.js-live-chat-header-icon',
		cookieButton: '.js-live-chat-drawer-cookie-button',
		refreshWindow: '.js-live-chat-drawer-refresh-window-button'
	};

	const state = {
		chatContainer: document.getElementById('live-chat-ui-container'),
		elements: {}
	};

	// Ensure the chat container exists before proceeding
	if (!state.chatContainer) {
		throw new LiveChatError('LiveChat UI container not found');
	}

	// Dynamically cache UI elements using uiSelectors
	function cacheChatUiDOMElements() {
		const cacheElement = (key, selector, parent) => {
			const element = parent.querySelector(selector);
			if (!element) console.warn(`⚠️ Warning: Missing UI element for ${key}`);
			return element;
		};

		Object.entries(uiSelectors).forEach(([key, selector]) => {
			if (typeof selector === 'object') {
				state.elements[key] = {};
				Object.entries(selector).forEach(([nestedKey, nestedSelector]) => {
					state.elements[key][nestedKey] = cacheElement(nestedKey, nestedSelector, state.chatContainer);
				});
			} else {
				state.elements[key] = cacheElement(key, selector, state.chatContainer);
			}
		});
	}

	async function loadTemplate(url, errorMessage) {
		try {
			const response = await fetch(url);
			if (!response.ok) throw new Error(errorMessage);
			return await response.text();
		} catch (error) {
			throw new Error(`${errorMessage}: ${error.message}`);
		}
	}

	async function handleTemplateRender(url) {
		const chatUiConfig = window.LiveChat.resources.ui || null;
		const template = await loadTemplate(url, `Failed to fetch chat UI template from ${url}`);
		return Mustache.render(template, chatUiConfig);
	}

	function chatUiHasClass(element, className) {
		if (!element) {
			console.warn(`chatUiHasClass: Element is missing when checking class "${className}"`);
			return false;
		}
		return element.classList.contains(className);
	}

	function chatUiHideElement(element) {
		element.classList.add('live-chat-hidden');
	}

	function chatUiShowElement(element) {
		element.classList.remove('live-chat-hidden');
	}

	function updateDrawerHeaderState() {
		const hasVisibleWarnings =
			!chatUiHasClass(state.elements.warnings.chatDrawerWarning, 'live-chat-hidden') ||
			!chatUiHasClass(state.elements.warnings.chatDrawerCookieWarning, 'live-chat-hidden');

		state.elements.headerIcon.classList.toggle(
			"live-chat-drawer__header-icon--content",
			!hasVisibleWarnings
		);
		state.elements.headerIcon.classList.toggle(
			"live-chat-drawer__header-icon--warning",
			hasVisibleWarnings
		);

		return hasVisibleWarnings;
	}

	function getIsFunctionalCookieCategory() {
		return window.OptanonActiveGroups && window.OptanonActiveGroups.indexOf('3') !== -1;
	}

	function getIsUserAwaitingChat() {
		return (
			(window.LiveChat.lpBeautyChatOrcData && window.LiveChat.lpBeautyChatOrcData.isUserAwaitingChat) ||
			(window.LiveChat.lpSupportChatOrcData && window.LiveChat.lpSupportChatOrcData.isUserAwaitingChat) ||
			false
		);
	}

	function closeDrawerOnClickOut() {
		const handleOutsideClick = (event) => {
			const oneTrustPopUp = document.querySelector(otherSelectors.oneTrustPopUp);
			if (
				!state.elements.chatDrawer.contains(event.target) &&
				!state.elements.floatingButton.contains(event.target) &&
				(!oneTrustPopUp || !oneTrustPopUp.contains(event.target))
			) {
				chatUiHideElement(state.elements.chatDrawer);
				if (getIsUserAwaitingChat()) showFloatingButtonLoadingState();
				removeOutsideClickListener();
			}
		}
		document.addEventListener("click", handleOutsideClick);
		removeOutsideClickListener = () => document.removeEventListener("click", handleOutsideClick);
	}

	function closeDrawerOnX() {
		state.elements.closeButton.addEventListener("click", () => {
			chatUiHideElement(state.elements.chatDrawer);
			// Terminate intent loop if exists and loading states.
			const isUserAwaitingChat = getIsUserAwaitingChat();
			if (!isUserAwaitingChat) return;
			window.LiveChat.onCloseButtonClick();
			const service = window.LiveChat.lpBeautyChatOrcData.isUserAwaitingChat ? 'artist' : 'support';
			const button = service === 'artist' ? state.elements.serviceButtons.artistButton : state.elements.serviceButtons.supportButton;
			toggleDrawerButton(button, service, false);
			hideFloatingButtonLoadingState();
		});
	}

	function showFloatingButtonLoadingState() {
		const userIntent = localStorage.getItem('live_chat_user_intent');
		if (!getIsUserAwaitingChat() && userIntent !== 'true') return;
		if (!chatUiHasClass(state.elements.chatDrawer, 'live-chat-hidden')) return;

		chatUiShowElement(state.elements.floatingButtonLoading);
		chatUiHideElement(state.elements.floatingButtonIcon);
	}

	function hideFloatingButtonLoadingState() {
		chatUiHideElement(state.elements.floatingButtonLoading);
		chatUiShowElement(state.elements.floatingButtonIcon);
	};

	function toggleDrawerTemplates(templateToShow) {
		const templates = [state.elements.chatDrawerSuccess, state.elements.warnings.chatDrawerWarning, state.elements.warnings.chatDrawerCookieWarning];

		templates.forEach(template => {
			if (template !== templateToShow) {
				chatUiHideElement(template);
			} else {
				chatUiShowElement(template);
			}
		});

		updateDrawerHeaderState();
	};

	function toggleDrawer() {
		state.elements.chatDrawer.classList.toggle('live-chat-hidden');
		if (
			chatUiHasClass(state.elements.warnings.chatDrawerCookieWarning, 'live-chat-hidden')
			&& chatUiHasClass(state.elements.warnings.chatDrawerWarning, 'live-chat-hidden')
		) {
			(getIsUserAwaitingChat() && chatUiHasClass(state.elements.chatDrawer, 'live-chat-hidden')) // If the user is awaiting chat, drawer is closed, and then clicks the floating button
				? showFloatingButtonLoadingState()
				: hideFloatingButtonLoadingState();
			toggleDrawerTemplates(state.elements.chatDrawerSuccess);
		}

		closeDrawerOnClickOut();
	}

	function toggleDrawerButton(button, service, isLoading) {
		button.querySelector(`.js-${service}-text`).classList.toggle('live-chat-hidden', isLoading);
		button.querySelector(`.js-${service}-loading`).classList.toggle('live-chat-hidden', !isLoading);
		button.querySelector(`.js-${service}-loading-text`).classList.toggle('live-chat-hidden', !isLoading);
	}

	function getServiceButtonSelector(services) {
		return services === 'artist'
			? uiSelectors.serviceButtons.supportButton
			: uiSelectors.serviceButtons.artistButton
	}

	function chatDrawerFinishedEvent(button, chatOrcData, service) {
		if (!chatOrcData) {
			toggleDrawerTemplates(state.elements.warnings.chatDrawerWarning);
			hideFloatingButtonLoadingState();
			toggleDrawerButton(button, service, false);
			throw new Error(`LiveChat: chatOrcData is undefined for service: ${service}`);
		}

		document.addEventListener(chatOrcData.intentLoopFinishedEventName, function () {
			if (!chatOrcData.isUserAwaitingChat) return;
			const buttonSelector = getServiceButtonSelector(service);
			const buttonEnabled = state.chatContainer.querySelector(buttonSelector);
			if (buttonEnabled) {
				buttonEnabled.disabled = false;
			}
			chatUiHideElement(state.elements.chatDrawer);
			hideFloatingButtonLoadingState();
			toggleDrawerButton(button, service, false);
		});
	}

	function chatDrawerErrorMessageEvent(chatOrcData) {
		document.addEventListener(chatOrcData.errorMessageEventName, function () {
			chatUiShowElement(state.elements.chatDrawer);
			toggleDrawerTemplates(state.elements.warnings.chatDrawerWarning);
			hideFloatingButtonLoadingState();
		});
	}

	function showCookieComplianceWarning() {
		state.elements.cookieButton.classList.add('ot-sdk-show-settings');
		state.elements.cookieButton.id = "ot-sdk-btn";
		state.elements.cookieButton.addEventListener("click", () => window.OneTrust.ToggleInfoDisplay());
		toggleDrawerTemplates(state.elements.warnings.chatDrawerCookieWarning);
	};

	function serviceButtonHandler() {
		return {
			artist: {
				button: state.elements.serviceButtons.artistButton,
				callback: () => window.LiveChat.onBeautyChatButtonClick()
			},
			support: {
				button: state.elements.serviceButtons.supportButton,
				callback: () => window.LiveChat.onSupportChatButtonClick()
			}
		};
	};

	function handleServiceSelection(service) {
		const serviceHandler = serviceButtonHandler()[service];

		if (!serviceHandler) {
			throw new Error(`❌ No service handler found for "${service}"`);
		}

		const { button, callback } = serviceHandler;
		const chatOrcData = service === 'artist' ? window.LiveChat.lpBeautyChatOrcData : window.LiveChat.lpSupportChatOrcData;

		toggleDrawerButton(button, service, true);
		chatDrawerFinishedEvent(button, chatOrcData, service);
		chatDrawerErrorMessageEvent(chatOrcData);

		// Ensure UI is not stuck on success if callback() fails
		try {
			if (callback) {
				callback();
			}
		} catch (callbackError) {
			console.error(`❌ LiveChat callback Error: ${callbackError.message}`);
			toggleDrawerTemplates(state.elements.warnings.chatDrawerWarning);
			hideFloatingButtonLoadingState();
		}
	}

	function disableOtherButton(buttonSelector) {
		const button = state.chatContainer.querySelector(buttonSelector);
		button.disabled = true;
	};

	function selectService(service) {
		localStorage.setItem('live_chat_selected_service', service);
		const buttonSelector = getServiceButtonSelector(service)
		disableOtherButton(buttonSelector);
		state.elements.buttonClicked = service;
		if (getIsFunctionalCookieCategory()) {
			handleServiceSelection(service);
		} else {
			showCookieComplianceWarning();
		}
	};

	async function initializeLivePerson() {
		const { manifest, resources } = window.LiveChat || {};
		const shouldLoadLivePerson = resources.liveperson.enabled;

		if (shouldLoadLivePerson) {
			await loadLivePersonAssets(manifest.liveperson, bucketPath);
		}
	}

	async function getCurrentDecision() {
		if (getIsFunctionalCookieCategory()) {
			if (!window?.lpTag?.site) initializeLivePerson();

			const buttonClicked = state.elements.buttonClicked;
			if (!buttonClicked) return;

			handleServiceSelection(buttonClicked);
			toggleDrawerTemplates(state.elements.chatDrawerSuccess);
		}
	}

	async function loadChatUi(url) {
		const chatUiTemplate = await handleTemplateRender(url);
		state.chatContainer.insertAdjacentHTML('afterbegin', chatUiTemplate);
		cacheChatUiDOMElements();

		const userIntent = localStorage.getItem('live_chat_user_intent');
		const selectedService = localStorage.getItem('live_chat_selected_service');

		// Bulletproofing local storage item if item remove is failed, as type of is string, hence always true if exists.
		if (userIntent === 'true') {
			showFloatingButtonLoadingState();
			if (selectedService) {
				selectService(selectedService);
			}
			localStorage.removeItem('live_chat_user_intent');
		} else if (selectedService) {
			localStorage.removeItem('live_chat_selected_service');
		}

		window.addEventListener('OneTrustGroupsUpdated', () => {
			getCurrentDecision();
		});
		state.elements.floatingButton.addEventListener("click", () => toggleDrawer());
		closeDrawerOnX();
		state.elements.serviceButtons.artistButton.addEventListener("click", () => selectService('artist'));
		state.elements.serviceButtons.supportButton.addEventListener("click", () => selectService('support'));
		state.elements.refreshWindow.addEventListener("click", () => {
			localStorage.setItem('live_chat_user_intent', "true");
			location.reload()
		});
	}

	async function initializeChatUI() {
		try {
			const { manifest, resources } = window.LiveChat || {};
			const missingConfig = !manifest || !resources;
			const hasValidManifest = Array.isArray(manifest.ui) && manifest.ui.length > 0;

			if (missingConfig) {
				throw new Error('Missing required properties in window.LiveChat object');
			}

			// Exit if chat ui is disabled or no manifest files
			if (!resources.ui.enabled || !hasValidManifest) return;

			// Filter and validate template files
			const assetPaths = manifest.ui.filter(file => file.endsWith('.mustache'));
			if (assetPaths.length === 0) return;

			const url = `${bucketPath}${assetPaths[0]}`;

			// Load the chat UI with valid templates
			await loadChatUi(url);
		} catch (error) {
			throw new LiveChatError(error.message);
		}
	}
	(async function () {
		await initializeChatUI();
	})();
}());
